import { FormGroup, Label } from 'reactstrap';
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import QInput from '_Components/Fields/QInput/QInput';
import { grayShades } from 'styles/abstracts/colors';

const StyledQInput = styled(QInput)`
  width: 100%;
`;

const StyledLabel = styled(Label)`
  color: ${grayShades.g800};
`;

const NameInputBenchmark = ({ t, name, dispatcher }) => {
  const [cardTitle, setCardTitle] = useState(name);
  const onNameChange = e => {
    setCardTitle(e.target.value);
    dispatcher(e.target.value);
  };

  useEffect(() => {
    setCardTitle(name);
  }, [name]);

  return (
    <>
      <FormGroup>
        <StyledLabel>{t('Name')}</StyledLabel> <br />
        <StyledQInput primary maxLength={50} value={cardTitle} onChange={onNameChange} />
      </FormGroup>
    </>
  );
};
export default withTranslation('card')(NameInputBenchmark);
